import { Button } from 'components/admin/ui/Button';
import { Chart } from 'components/admin/ui/Chart';
import { ConfirmationModal } from 'components/admin/ui/ConfirmationModal';

interface IFileUploadProgressModalProps {
  abortUpload: () => void;
  className?: string;
  canAbortUpload?: boolean;
  isVisible: boolean;
  handleClose: () => void;
  message: string;
  uploadPercentage: number;
}

export const FileUploadProgressModal = ({
  abortUpload,
  className,
  canAbortUpload = true,
  isVisible,
  handleClose,
  message,
  uploadPercentage,
}: IFileUploadProgressModalProps) => {
  return (
    <ConfirmationModal
      className={className}
      isVisible={isVisible}
      onClose={handleClose}
    >
      <ConfirmationModal.Header className="d-flex">
        <Chart.RadialProgress
          percentage={uploadPercentage}
          size={72}
          strokeWidth={12}
        />
      </ConfirmationModal.Header>

      <ConfirmationModal.Body>
        <ConfirmationModal.Confirmation
          heading="Uploading file..."
          details={message}
        />
      </ConfirmationModal.Body>

      <ConfirmationModal.Footer>
        <Button color="red" isLoading={!canAbortUpload} onClick={abortUpload}>
          Cancel upload
        </Button>
      </ConfirmationModal.Footer>
    </ConfirmationModal>
  );
};
